import { Container } from "@pixi/react";
import React, { memo } from "react";
import Divider from "../Divider/Divider";
import { Settings } from "../../../settings";

const DividerReelset = memo(
  ({ symbolHeight, dividerDimensions, reelSpacing }) => {
    const dividerReels = Array.from(
      { length: Settings.REEL_COUNT - 1 },
      (_, idx) => idx
    );

    return (
      <Container
        name="dividers"
        zIndex={3}
        y={(-symbolHeight * Settings.SYMBOLS_VISIBLE) / 2}
        x={0}
      >
        {dividerReels.map((index) => (
          <Divider
            key={index}
            index={index}
            x={reelSpacing * (index - (Settings.REEL_COUNT - 1) / 2 + 0.5)}
            dividerDimensions={dividerDimensions}
          />
        ))}
      </Container>
    );
  }
);

export default DividerReelset;
